import type { FC } from "react";
import { NumberContainer } from "app/components/React/TableTopOverview/TableTopOverviewStyledComponents";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import type { INumberComponentProps } from "app/components/React/TableTopOverview/TableTopOverviewTypes";

export const NumberValue: FC<INumberComponentProps> = ({ isLoading, children }) => {
    if (isLoading) {
        return (
            <PixelPlaceholderLoader
                width={70}
                height={20}
            />
        );
    } else {
        return <NumberContainer>{children}</NumberContainer>;
    }
};
